import axiosInstance from "./axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/customer";

export async function createPortalSession() {
  const response = await instance.post(`/create-portal-session`);
  return response.data;
}

export async function getPaymentStatus() {
  const response = await instance.get("/get-payment-status");
  return response.data;
}

export async function getCustomerSession() {
  const response = await instance.get("/stripe-session-client-secret");
  return response.data;
}

export async function cancelSubscription() {
  const response = await instance.post("cancel-subscription");
  return response.data;
}

export async function getCancellationDate() {
  const response = await instance.get("/cancellation-date");
  return response.data;
}

export async function renewSubscription() {
  const response = await instance.post("/renew-subscription", {
    timeout: 60000,
  });
  return response.data;
}
